export type UserSettingsPage =
  | null
  | 'profilePicture'
  | 'personal'
  | 'email'
  | 'password'
  | 'notifications'
  | 'onboarding';

export const USER_SETTINGS_HASH_PREFIX = '#user-settings-open';
/** Emails and API redirects still use this pre-split hash. */
export const LEGACY_USER_SETTINGS_HASH_PREFIX = '#settings-open';

export function isUserSettingsHash(hash: string): boolean {
  return (
    hash.startsWith(USER_SETTINGS_HASH_PREFIX) ||
    hash === LEGACY_USER_SETTINGS_HASH_PREFIX ||
    hash.startsWith(`${LEGACY_USER_SETTINGS_HASH_PREFIX}:`)
  );
}

export function canonicalizeUserSettingsHash(hash: string): string {
  if (hash === LEGACY_USER_SETTINGS_HASH_PREFIX) {
    return USER_SETTINGS_HASH_PREFIX;
  }
  if (hash.startsWith(`${LEGACY_USER_SETTINGS_HASH_PREFIX}:`)) {
    return `${USER_SETTINGS_HASH_PREFIX}${hash.slice(
      LEGACY_USER_SETTINGS_HASH_PREFIX.length
    )}`;
  }
  return hash;
}

/**
 * Parses the subpage from a user-settings hash
 * (e.g. `#user-settings-open:personal`).
 */
export function parseSubpageFromHash(hash: string): UserSettingsPage {
  if (hash.endsWith(':profilePicture')) {
    return 'profilePicture';
  } else if (hash.endsWith(':personal')) {
    return 'personal';
  } else if (hash.endsWith(':email')) {
    return 'email';
  } else if (hash.endsWith(':password')) {
    return 'password';
  } else if (hash.endsWith(':notifications')) {
    return 'notifications';
  } else if (hash.endsWith(':onboarding')) {
    return 'onboarding';
  }
  return null;
}
